// this enum need to update for theme and reference
export enum Color {
  Purple = 'purple',
  Red = 'red',
  Orange = 'orange',
  Yellow = 'yellow',
  Green = 'green',
  Cyan = 'cyan',
  Blue = 'blue',
  White = 'white',
  Black = 'black',
  Gray = 'gray',
  Violet = 'violet',
}
export enum NonCssColor {
  Medal = 'medal',
  Clickable = 'clickable',
  Rainbow = 'rainbow',
  GameShowBubble = 'gameShowBubble',
}
